import Axios from 'axios';
import server from 'util/Server';
import moment from 'moment';
import Swal from "sweetalert2"
import { sessionCaducada } from 'util/funciones'

export const getVentas = async (data) => {
    return new Promise(function (resolve, reject) {
        const headers = {
            Authorization: server.obtenerToken(),
            versionapp: server.versionApp,
            versioncode: server.versionCode,
            fecha: moment().format(),
            aplicacion: server.aplicacion,
            identificadordispositivo: server.aplicacion
        }
        Axios.post(server.host + server.puertoMovimiento + "/api/reportes/ventas/all", data, { headers: headers })
            .then((response) => {
                if (response.data.data.length === 0) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'No se encontraron datos con las fechas seleccionadas',
                        text: 'Intente con otras fechas',
                    })
                    return;
                }
                let datos = response.data.data
                if (datos != null) {
                    resolve(datos)
                } else if (response.status === server.responseSesionCaducada) {
                    let datos = [];
                    resolve(datos);
                    sessionCaducada()
                } else {
                    resolve([])
                }
            })
            .catch((err) => {
                console.error(err);
                reject(err, undefined);
            });
    });
};

export const getTicketsReporteVentas = (body) => {
  return new Promise(function (resolve, reject) {
    Axios.post(server.host + server.puerto_reporte_service + "/api/v2/ventas/tirilla", body, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data
          resolve(datos)
        } else if (res.status === server.responseSesionCaducada) {
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  });
}

export const getTicketsReporteCierreDiario = (body) => {
  return new Promise(function (resolve, reject) {
    Axios.post(server.host + "10445" + "/api/reportes/cierre-diario/tirilla", body, { headers: { Authorization: server.obtenerToken() } })
      .then((res) => {
        if (res.status === server.responseOK) {
          const datos = res.data
          resolve(datos)
        } else if (res.status === server.responseSesionCaducada) {
          sessionCaducada()
        }
      })
      .catch((err) => {
        console.error(err)
        reject(err)
      })
  });
}

export const obtenerDetallesVenta = async (identificadorVenta) => {
    return new Promise(function (resolve, reject) {
        Axios.get(server.host + server.puertoMovimiento + "/api/reportes/obtener-detalles/" + identificadorVenta, { headers: { Authorization: server.obtenerToken() } })
            .then((res) => {
                if (res.status === server.responseOK) {
                    const datos = res.data.data
                    resolve(datos)
                } else if (res.status === server.responseSesionCaducada) {
                    sessionCaducada()
                }
            })
            .catch((err) => {
                console.error(err)
                reject(err)
            })
    });
};
export const obtenerTotalizadoresVenta = async (body) => {
    delete body.estado
    return new Promise(function (resolve, reject) {
        Axios.get(server.host + server.puertoMovimiento + "/api/v2/venta_totalizado", { headers: { Authorization: server.obtenerToken(),
         },params:body })
            .then((res) => {
                if (res.status === server.responseOK) {
                    const datos = res.data
                    resolve(datos)
                } else if (res.status === server.responseSesionCaducada) {
                    sessionCaducada()
                }
            })
            .catch((err) => {
                console.error(err)
                reject(err)
            })
    });
};


export const sendGenerateMasiveReportService = async (body) =>{
        const response = await Axios.post(server.host + server.puertoMovimiento +`/api/v2/get_reporte_ventas_regionales/`,body,{headers: { Authorization: server.obtenerToken() }})
        return response.data
}

export const getMasiveReports = async (usuario) =>{
        const response = await Axios.get(server.host + server.puertoMovimiento + `/api/v2/get_reporte_ventas_regionales/${usuario}`,{headers: { Authorization: server.obtenerToken() }})
        return response.data
}

export const getReportType = async (usuario_id) =>{
    const response = await Axios.get(server.host + server.puertoMovimiento + `/api/reportes/getTiporeporte/${usuario_id}`,{headers: { Authorization: server.obtenerToken() }})
    return response.data
}

export const downloadMasiveFile = async (URL_PATH) =>{
    try {
        const link = document.createElement('a');
        link.href = URL_PATH
        link.click();

    } catch (error) {
        console.log('ERROR::',error);
        throw new Error('Error')
        return {error:error}
    }
}

